import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { ClientAddressEditComponent } from '../client-address-edit/client-address-edit.component';
import { ClientEditComponent } from '../client-edit/client-edit.component';
import { ClientDiscountPercenatageComponent } from '../client-discount-percenatage/client-discount-percenatage.component';
import { MatDialog } from "@angular/material";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { PaymentRefundComponent } from '../../mnt-invoices/payment-refund/payment-refund.component';
import { ArtworkfilesComponent } from '../artworkfiles/artworkfiles.component';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { MailPublicUrlComponent } from '../../mnt-invoices/mail-public-url/mail-public-url.component';
import { CreateClientComponent } from '../../mnt-master/create-client/create-client.component';

@Component({
    selector: 'app-view-client',
    templateUrl: './view-client.component.html',
    styleUrls: ['./view-client.component.css']
})
export class ViewClientComponent implements OnInit {
    @Input() id: any;
    @Output() toggleForm = new EventEmitter<boolean>();
    public loading = false;
    public billingAddress: Array<any> = [];
    public shippingAddress: Array<any> = [];
    public discountPercentage: any;
    public ProfileDetail: Array<any> = [];
    public editClientData: any = {};
    public showAddress = false;
    public clientName: string;
    public isPublicQuoteCreation = false;
    public openSideBar: boolean = false;
    public companyId = null;
    public userId: any;
    public addressId: any;
    public showForm = false;
    constructor(private fb: FormBuilder,
        private _flashMessagesService: FlashMessagesService,
        private CommonService: CommonService,
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private CommonProjectDataService: CommonProjectDataService
    ) {
        this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    }

    ngOnInit() {
        this.getClientDetail(this.id);
    }

    backToList(): void {
        this.router.navigate(["/clients/listing"]);
    }
    toggleClass() {
        this.openSideBar = !this.openSideBar;
    }
    createQuote = function () {
        let userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (userDetails && userDetails.site_data.site_url) {
            let siteUrl = userDetails.site_data.site_url.trim(); //this.editClientData.site_url.trim();
            let newStr = siteUrl.substring(siteUrl.length - 1, siteUrl.length);
            if (newStr != '/') {
                return siteUrl + '/processdata/?pfutoken=' + this.editClientData.token;
            }
            else {
                return siteUrl + 'processdata/?pfutoken=' + this.editClientData.token;
            }
        }
    }

    getClientDetail = function (id) {
        this.loading = true;
        this.clientOptions = {};
        this.CommonService.apiService(
            "GET",
            "user/" + id,
            this.clientOptions
        ).subscribe(
            (response: any) => {
                this.loading = false;
                if (response.status === true) {
                    if (response.data) {
                        this.editClientData = response.data;
                        this.billingAddress = response.data.billingAddress;
                        this.shippingAddress = response.data.shippingAddress;
                        this.ProfileDetail = response.data;
                        this.clientName = response.data.first_name;
                        if (response.data.middle_name != null && response.data.middle_name != '') {
                            this.clientName = this.clientName + ' ' + response.data.middle_name;
                        }
                        this.clientName = this.clientName + ' ' + response.data.last_name;
                        this.discountPercentage = response.data.discount_percentage;
                        if (response.data.company_id) {
                            this.companyId = response.data.company_id;
                        }
                    }
                }
            },
            err => {
                this.loading = false;
                console.log(err);
            }
        );
    };

    openDialog(type): void {
        const dialogRef = this.dialog.open(ClientAddressEditComponent, {
            width: "800px",
            disableClose: true,
            data: {
                name: "Admin",
                message: "Client",
                manageData: { client_id: this.id, type: type }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log(result);
            if (result) {
                if (result == "success") {
                    this.getClientDetail(this.id);
                }
                else if (result == "showAddress") {
                    this.showAddress = true;
                }
                else {
                    if (result.statusType && result.statusType == 'editAddress') {
                        this.showForm = true;
                        this.addressId = result.addressId;
                        this.userId = result.userId;
                        window.scrollTo(0, 0);
                    }
                }
            }
        });
    }

    openClientProfileDialog(): void {
        this.getClientDetail(this.id);
        const dialogRef = this.dialog.open(ClientEditComponent, {
            width: "800px",
            disableClose: true,
            data: {
                user_id: this.id,
                manageData: this.editClientData,
                companyId: this.companyId
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == "success") {
                this.getClientDetail(this.id);
            }
        });
    }

    openDiscountDialog(): void {
        const dialogRef = this.dialog.open(ClientDiscountPercenatageComponent, {
            width: "300px",
            disableClose: true,
            data: {
                user_id: this.id,
                manageData: { diccount_percentage: this.discountPercentage }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == "success") {
                this.getClientDetail(this.id);
            }
        });
    }

    viewclientAddress(loading) {
        this.showAddress = !loading;
    }

    trackByFn(index: any, item: any) {
        return index;
    }
    viewInvoiceCart(id) {
        if (this.isPublicQuoteCreation == true) {
            this.router.navigate([`/builder/invoices/${id}`]);
        }
        else {
            this.router.navigate([`/invoices/${id}`]);
        }
    }
    viewQuotesCart(id) {
        if (this.isPublicQuoteCreation == true) {
            this.router.navigate([`/builder/quote/${id}`]);
        }
        else {
            this.router.navigate([`/quote/${id}`]);
        }

    }
    duplicateInvoice(id) {
        this.router.navigate(['/quote', { id: id, type: 'Duplicate' }]);
    }


    openDeleteDialog(id: number): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: "250px",
            data: {
                name: "Admin",
                message: "Are you sure you want to delete this Quote",
                manageData: { quote_id: id }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.quote_id) {
                this.deleteQuote(result.quote_id);
            }
        });
    }

    deleteQuote = function (quote_id) {
        localStorage.getItem("userID")
        this.clientOptions = {};
        this.CommonService.apiService(
            "DELETE",
            "quote/" + localStorage.getItem("userID") + "/" + quote_id,
            this.clientOptions
        ).subscribe(
            (response: any) => {
                if (response.status === true) {
                    this._flashMessagesService.show("Quote deleted successfully!", {
                        cssClass: "alert-success",
                        timeout: 5000
                    });
                    this.getClientDetail(this.id);
                }
            },
            err => {
                this._flashMessagesService.show(err.error.message, {
                    cssClass: "alert-danger",
                    timeout: 5000
                });
            }
        );
    };

    openPaymentRefundDialog(invoiceId, payAmount, refundedAmount, transactions): void {
        const dialogRef = this.dialog.open(PaymentRefundComponent, {
            width: "500px",
            disableClose: true,
            data: {
                user_id: localStorage.getItem("userID"),
                invoice_id: invoiceId,
                pay_Amount: payAmount,
                refunded_Amount: refundedAmount,
                transactions: transactions
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == "success") {
                this.getClientDetail(this.id);
            }
        });
    }

    openInvoiceFileDialog(): void {
        const dialogRef = this.dialog.open(ArtworkfilesComponent, {
            width: "95%",
            maxWidth: "auto",
            disableClose: true,
            data: {
                userId: this.id
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    inviteClient = function () {
        this.loading = true;
        this.clientOptions = {
            id: localStorage.getItem('userID'),
            user_id: this.id,
        };
        this.CommonService.apiService(
            "POST",
            "user/invite",
            this.clientOptions
        ).subscribe(
            (response: any) => {
                this.loading = false;
                if (response.status === true) {
                    this._flashMessagesService.show(response.message, {
                        cssClass: "alert-success",
                        timeout: 5000
                    });
                }
            },
            err => {
                this.loading = false;
                console.log(err);
            }
        );
    };

    newOrder() {
        this.CommonProjectDataService.storeClientId(this.clientName);
        this.CommonProjectDataService.storeQuoteRequest(true);
        this.router.navigate(["/invoices/order"]);
    }

    openInvoiceDeleteDialog(id: number): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: "250px",
            data: {
                name: "Admin",
                message: "Are you sure you want to delete this invoice",
                manageData: { invoice_id: id }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.invoice_id) {
                this.deleteInvoice(result.invoice_id);
            }
        });
    }

    deleteInvoice = function (invoice_id) {
        this.clientOptions = {};
        this.CommonService.apiService(
            "DELETE",
            "order/" + localStorage.getItem("userID") + "/" + invoice_id,
            this.clientOptions
        ).subscribe(
            (response: any) => {
                if (response.status === true) {
                    this._flashMessagesService.show("invoice deleted successfully!", {
                        cssClass: "alert-success",
                        timeout: 5000
                    });
                    this.getClientDetail(this.id);
                }
            },
            err => {
                this._flashMessagesService.show(err.error.message, {
                    cssClass: "alert-danger",
                    timeout: 5000
                });
            }
        );
    };

    openPublicUrlEmailDialog(clientEmail): void {
        const dialogRef = this.dialog.open(MailPublicUrlComponent, {
            width: "500px",
            data: {
                order_id: '',
                client_mail: clientEmail
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }
    // Public URL on customer portal
    viewInvoiceOrder(orderUrl) {
        if (orderUrl) {
            const urlParts = orderUrl.split("/");
            const urlToken = urlParts[urlParts.length - 1];
            this.router.navigate(['/builder/invoice/' + urlToken]);
        }
    }

    openAddUserDialog(): void {
        const dialogRef = this.dialog.open(CreateClientComponent, {
            width: "900px",
            disableClose: true,
            data: { company_id: this.id }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    viewUser(userId) {
        this.router.navigate(['/clients/listing', { id: userId }]);
    }

    openUserDeleteDialog(id: number): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: "250px",
            data: {
                name: this.clientName,
                message: "Are you sure you want to delete this User",
                manageData: { client_id: id }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.client_id) {
                this.deleteClient(result.client_id);
            }
        });
    }

    deleteClient = function (id) {
        this.clientOptions = {};
        this.CommonService.apiService(
            "DELETE",
            "user/" + id,
            this.clientOptions
        ).subscribe(
            (response: any) => {
                if (response.status === true) {
                    this._flashMessagesService.show("User deleted successfuly!", {
                        cssClass: "alert-success",
                        timeout: 5000
                    });
                    this.getClientDetail(this.id);
                }
            },
            err => {
                this._flashMessagesService.show(err.error.message, {
                    cssClass: "alert-danger",
                    timeout: 5000
                });
            }
        );
    };

    showClientAddressForm(loading) {
        this.addressId = null;
        this.userId = this.id;
        this.showForm = !loading;
        this.openDialog('Shipping');
    }

    generatePasswordLink = function (id) {
        this.loading = true;
        const formData = new FormData();
        formData.append('id', localStorage.getItem("userID"));
        formData.append('user_id', id);
        this.CommonService.apiService(
            "POST",
            "user-password/generate",
            formData
        ).subscribe(
            (response: any) => {
                if (response.status === true) {
                    this._flashMessagesService.show(response.message, {
                        cssClass: "alert-success",
                        timeout: 5000
                    });
                    this.loading = false;
                }
            },
            err => {
                this._flashMessagesService.show(err.error.message, {
                    cssClass: "alert-danger",
                    timeout: 5000
                });
                this.loading = false;
            }
        );
    };
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/view-client/view-client.component.ts